import axios from "axios";
/**
 * Single axios instance for the public SPA.
 *
 * - `baseURL: "/api"` — same-origin, first-party. The SPA and the OPINK API are
 *   served behind the same host (US-0.16.b ingress), so no CORS and no cross-site
 *   cookies are involved. The public path MUST NOT embed the internal service name
 *   `opink`: the SPA pod's nginx proxies `/api/*` to OPINK internally.
 * - `withCredentials: false` — this surface is token-gated via the URL path
 *   (`:token`), NOT via cookies/Keycloak. There is no auth interceptor.
 *
 * US-2.2 / US-5.19 add their endpoint calls on top of this client.
 */
export const httpClient = axios.create({
    baseURL: "/api",
    withCredentials: false,
    headers: {
        "Content-Type": "application/json",
    },
});
